import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputLabel } from '../../../../components/form/FormInputLabel';

export const ReasonDetailField = ({ control, errors, reasonDetailFieldName, reasonDetailLabel, showCustomReason }) => {
  const { t } = useTranslation();
  if (!showCustomReason) return null;

  return (
    <div className='flex flex-col gap-1'>
      <FormInputLabel label={reasonDetailLabel || t('REASON_DETAIL')} isRequired />
      <Controller
        control={control}
        name={reasonDetailFieldName}
        rules={{ required: showCustomReason }}
        render={({ field }) => (
          <TextField
            {...field}
            multiline
            rows={4}
            error={!!errors[reasonDetailFieldName]}
            style={{ gridColumn: '1/3' }}
          />
        )}
      />
      {errors[reasonDetailFieldName] && <FormHelperText error>{errors[reasonDetailFieldName].message}</FormHelperText>}
    </div>
  );
};

